// extracted by mini-css-extract-plugin
module.exports = {"work-info":"style_work-info__3MgQo","order-number":"style_order-number__3fNRS","title":"style_title__2sKSM","bottom-line":"style_bottom-line__zH-n6"};